import React from "react"
import { Tile } from "../../../shared/components"

class ItemStockTile extends React.Component {
    render() {
        return <Tile {...this.props} />
    }
}

export default ItemStockTile